import styled from 'styled-components';
import academyStyles from './academy-styles';

const AcademyIconSvgEvent = (props) => {
  const defaultWidth = 16;
  const defaultHeight = 16;

  const { color, height = defaultHeight } = props;
  const calculatedWidth = (defaultWidth / defaultHeight) * height;

  return (
    <AcademyIconWrapper width={calculatedWidth} height={height} role="none">
      <canvas width={calculatedWidth} height={height} />
      <svg width={calculatedWidth} height={height} viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.5">
          <g transform="translate(-1436.000000, -1950.000000)">
            <g transform="translate(1410.000000, 1732.000000)">
              <g transform="translate(24.000000, 216.000000)">
                <path
                  d="M6,2 L6,3 L8,3 L8,2 L9,2 L9,3 L11,3 L11,2 L12,2 L12,3 L14,3 L14,2 L15,2 L15,3 L18,3 L18,18 L2,18 L2,3 L5,3 L5,2 L6,2 Z M17,16 L3,16 L3,17 L17,17 L17,16 Z M5,4 L3,4 L3,15 L16.999,15 L17,4 L15,4 L15,5 L14,5 L14,4 L12,4 L12,5 L11,5 L11,4 L9,4 L9,5 L8,5 L8,4 L6,4 L6,5 L5,5 L5,4 Z M11,7 L11,13 L10,13 L10,8 L9,8 L9,7 L11,7 Z"
                  fill={color || academyStyles.common.contentTypeIconColor}
                  fillRule="nonzero"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </AcademyIconWrapper>
  );
};

export default AcademyIconSvgEvent;

const AcademyIconWrapper = styled.div`
  display: inline-block;
  position: relative;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  canvas {
    visibility: hidden;
  }
  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
  }
`;
